import type { ReactNode } from "react";

/** The existing Home member-card layout, shared with the Labs callout. */
export function HomeFeatureCard({
  label,
  meta,
  children,
  actions,
}: {
  label: string;
  meta?: ReactNode;
  children: ReactNode;
  actions: ReactNode;
}) {
  return (
    <section className="bg-black bg-[url('/brand/code_bg.jpg')] bg-cover bg-center text-white">
      <div className="flex flex-wrap items-center justify-between gap-10 px-15 py-10 border-b border-white/10 bg-[#353535]">
        <span className="font-mono text-12 uppercase text-white/60 leading-110">
          {label}
        </span>
        {meta && (
          <span className="font-mono text-13 uppercase text-white leading-110">
            {meta}
          </span>
        )}
      </div>
      {children}
      <div className="flex flex-wrap border-t border-[#5D5D5D]">{actions}</div>
    </section>
  );
}
